import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { therapyPlanningAction } from '../../actions/constant';
import therapyPlanningService from '../../../services/apiServices/therapyPlanning/therapyPlanning';

const {
  GET_PLAN_OF_CARE_FAILURE,
  GET_PLAN_OF_CARE_REQUEST,
  GET_PLAN_OF_CARE_SUCCESS,
  GET_PLAN_OF_CARE_LOADING,
} = therapyPlanningAction;

function* getPlanOfCare(payload: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PLAN_OF_CARE_LOADING });
    const response = yield call(therapyPlanningService.getPlanOfCare, payload?.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PLAN_OF_CARE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PLAN_OF_CARE_FAILURE, payload: error });
  }
}

function* getPlanOfCareSage() {
  yield takeEvery(GET_PLAN_OF_CARE_REQUEST, getPlanOfCare);
}

export default getPlanOfCareSage;
